/* ============================================================
   B4 Quick Buy — assets/b4-quick-buy.js
   Dołącz jednorazowo w main-product.liquid (lub theme.liquid):
   {{ 'b4-quick-buy.js' | asset_url | script_tag }}
   ============================================================ */

(function () {
  'use strict';

  // ── Inicjalizacja wszystkich widgetów na stronie ─────────────
  function initAll() {
    document.querySelectorAll('.b4-quick-buy').forEach(initWidget);
  }

  // ── Pojedynczy widget ────────────────────────────────────────
  function initWidget(widget) {
    if (widget.dataset.b4Init) return;
    widget.dataset.b4Init = '1';

    const form        = widget.querySelector('[data-product-form]');
    const variantInput = widget.querySelector('.b4-quick-buy__variant-id');
    const addBtn      = widget.querySelector('[data-add-to-cart]');
    const wishBtn     = widget.querySelector('.b4-quick-buy__wishlist');
    const msgEl       = widget.querySelector('.b4-quick-buy__message');
    const productUrl  = widget.dataset.productUrl;

    // Upewnij się, że rodzic ma position: relative
    const cardWrapper = widget.closest('.card-wrapper');
    if (cardWrapper) {
      const pos = getComputedStyle(cardWrapper).position;
      if (pos === 'static') cardWrapper.style.position = 'relative';
    }

    // ── Neutralizuj .full-unstyled-link który nakrywa widget ───────
    // Link leży wyżej w DOM niż widget (.card__content po .card__inner)
    // więc naturalny stacking powoduje że przesłania widget mimo z-index:9999.
    // Rozwiązanie: wyłączamy pointer-events na linku TYLKO podczas hover
    // na .card-wrapper — poza hoverem link działa normalnie.
    if (cardWrapper) {
      // Wyłącz wszystkie linki-nakładki trwale
      const overlayLinks = cardWrapper.querySelectorAll('.full-unstyled-link, a[class*="card-link"]');
      overlayLinks.forEach(l => l.style.pointerEvents = 'none');

      // Dodaj własny handler nawigacji na oba .card__content
      // Klikamy w oryginalny link (pointer-events:none ale href działa)
      // dzięki temu przeglądarka pokazuje URL w pasku statusu
      const navLink = overlayLinks[0];
      const card = cardWrapper.querySelector('.card');
      if (card && navLink) {
        card.querySelectorAll('.card__content').forEach(el => {
          el.style.cursor = 'pointer';
          el.addEventListener('click', (e) => {
            if (widget.contains(e.target) || e.target === widget) return;
            navLink.click();
          });
        });
      }
    }

    // Blokuj propagację kliknięć z widgetu
    widget.addEventListener('click', (e) => {
      e.stopPropagation();
      const anchor = e.target.closest('a');
      if (anchor && widget.contains(anchor)) e.preventDefault();
    });
    widget.addEventListener('mousedown', (e) => e.stopPropagation());

    // ── Zmiana opcji → wyznaczenie wariantu ─────────────────────
    const optionGroups = widget.querySelectorAll('.b4-quick-buy__option-group');

    function getSelectedOptions() {
      const values = [];
      optionGroups.forEach((group) => {
        const checked = group.querySelector('.b4-quick-buy__swatch-input:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    async function updateVariant() {
      const selected = getSelectedOptions();

      // Jeśli nie wszystkie opcje wybrane — wyczyść wariant
      if (selected.some((v) => v === null)) {
        variantInput.value = '';
        setAddBtnState(false);
        return;
      }

      try {
        // Pobieramy dane produktu przez Shopify AJAX API
        const res  = await fetch(`${productUrl}.js`);
        const data = await res.json();

        const match = data.variants.find((v) => {
          return selected.every((val, i) => v[`option${i + 1}`] === val);
        });

        if (match) {
          variantInput.value = match.id;
          // Aktualizuj wishlist data-variant-id
          if (wishBtn) wishBtn.dataset.variantId = match.id;
          setAddBtnState(match.available);
          // Aktualizuj dostępność swatchy dla pozostałych opcji
          updateSwatchAvailability(data.variants, selected);
        } else {
          variantInput.value = '';
          setAddBtnState(false);
        }
      } catch (e) {
        console.warn('[B4 Quick Buy] Nie można pobrać wariantów:', e);
      }
    }

    // ── Aktualizacja dostępności swatchy ─────────────────────────
    function updateSwatchAvailability(variants, selected) {
      optionGroups.forEach((group, groupIdx) => {
        const inputs = group.querySelectorAll('.b4-quick-buy__swatch-input');
        inputs.forEach((input) => {
          const testSelected = [...selected];
          testSelected[groupIdx] = input.value;

          const available = variants.some((v) => {
            return testSelected.every(
              (val, i) => val === null || v[`option${i + 1}`] === val
            ) && v.available;
          });

          const label = group.querySelector(`label[for="${input.id}"]`);
          if (!available) {
            input.disabled = true;
            label && label.classList.add('b4-quick-buy__swatch--unavailable');
          } else {
            input.disabled = false;
            label && label.classList.remove('b4-quick-buy__swatch--unavailable');
          }
        });
      });
    }

    // ── Stan przycisku koszyka ───────────────────────────────────
    function setAddBtnState(available) {
      if (!addBtn) return;
      addBtn.disabled = !available;
    }

    // ── Szerokość swatchy zależna od liczby wariantów ───────────
    widget.querySelectorAll('.b4-quick-buy__swatches').forEach((swatches) => {
      const count = swatches.querySelectorAll('.b4-quick-buy__swatch').length;
      let basis;
      if (count <= 2)      basis = 'calc(40% - 3px)';
      else if (count === 3) basis = 'calc(30% - 4px)';
      else                  basis = null; // 4+ — naturalna szerokość
      if (basis) {
        swatches.querySelectorAll('.b4-quick-buy__swatch').forEach(s => {
          s.style.flexBasis = basis;
          s.style.minWidth  = '0';
          s.style.justifyContent = 'center';
        });
      }
    });

    // ── Nasłuchiwanie zmian opcji ────────────────────────────────
    widget.querySelectorAll('.b4-quick-buy__swatch-input').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    // ── Dodaj do koszyka ─────────────────────────────────────────
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        if (!variantInput.value) {
          showMessage('Wybierz wariant', true);
          return;
        }

        addBtn && addBtn.classList.add('is-loading');
        clearMessage();

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: parseInt(variantInput.value, 10),
              quantity: 1,
            }),
          });

          if (!res.ok) {
            const err = await res.json();
            throw new Error(err.description || 'Błąd dodawania');
          }

          window.location.href = '/cart';



        } catch (err) {
          showMessage(err.message, true);
        } finally {
          addBtn && addBtn.classList.remove('is-loading');
        }
      });
    }

    // ── Wishlist (opcjonalnie: integracja z iWish) ───────────────
    if (wishBtn) {
      wishBtn.addEventListener('click', () => {
        // iWish / Growave / własna obsługa
        const event = new CustomEvent('b4:wishlist:toggle', {
          detail: {
            productId: widget.dataset.productId,
            variantId: wishBtn.dataset.variantId,
          },
          bubbles: true,
        });
        wishBtn.dispatchEvent(event);

        // Wizualny toggle (właściwy stan ustawi aplikacja wishlist)
        wishBtn.classList.toggle('is-wished');
      });
    }

    // ── Helpers ──────────────────────────────────────────────────
    function showMessage(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.classList.toggle('is-error', isError);
      clearTimeout(msgEl._timer);
      msgEl._timer = setTimeout(clearMessage, 3000);
    }

    function clearMessage() {
      if (!msgEl) return;
      msgEl.textContent = '';
      msgEl.classList.remove('is-error');
    }
  }

  // ── Uruchom po załadowaniu DOM ───────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // ── Obsługa dynamicznie dodawanych kart (infinite scroll itp.) ─
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.b4-quick-buy:not([data-b4-init])').forEach(initWidget);
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();